module.exports = __webpack_public_path__ + "img/emoji-happy.a0049a79.svg";